import { useQuery } from '@tanstack/react-query';
import { getProviderPublicProfile } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';

export const useProviderPublicMatchingProfile = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryFn: () => getProviderPublicProfile(providerId),
    queryKey: [ 'provider-public-matching-profile', providerId ],
    select: r => r.data,
    staleTime: Infinity,
    ...opts,
  });
};
